export default function First() {
  return (
    <>
      <g id="g1">
        <path
          d="m 214.93087,95.158328 0.005,-73.915887 L 4.01538,256.5 c 0,0 -7.49986,3.5 -1.99993,15.5 5.49993,12 15.00005,6.5 15.00005,6.5 z"
          fill="url(#paint0_linear_527_14)"
          fillOpacity="0.9"
        />
      </g>
      <defs id="defs2">
        <linearGradient
          id="paint0_linear_527_14"
          x1="4.01539"
          y1="263.513"
          x2="250.162"
          y2="84.0368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE32B" />
          <stop offset="1" stopColor="#B60C00" />
        </linearGradient>
      </defs>
    </>
  );
}
